var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('div',{attrs:{"id":"message-box"}}),_c('div',{staticClass:"loading",attrs:{"id":"mloading"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }